/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { StudentCommentOutput } from './studentCommentOutput';

export interface PltStudentComment {
  id?: string;
  studentComment: StudentCommentOutput;
}
